import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { DialogsService } from '../../../shared/components/dialogs/dialogs.service';
import { InvoiceService } from '../invoice/invoice.service';
import { DeliveryNoteListComponent } from './deliverynote-list.component';
import { ConceptService } from '../../concept/concept/concept.service';
import { PreinvoiceService } from '../preinvoice/preinvoice.service';
import { ConceptModel } from '../../concept/concept/concept.model';
import { InvoiceModel } from '../invoice/invoice.model';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-deliverynotepublish',
    templateUrl: './deliverynote-dialog-publish.component.html',
    styleUrls: ['./deliverynote.component.css'],
    standalone: false
})
export class DeliveryNoteDialogPublishComponent implements OnInit {
  uid: string = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error = false;
  ready = false;

  // Control de los 15 días a la publicación
  canPublishDeliveryNoteFifteenDays: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DeliveryNoteListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private invoiceService: InvoiceService,
    private dialogsService: DialogsService,
    private conceptService: ConceptService,
    private preinvoiceService: PreinvoiceService
  ) { }

  //------------ Conceptos con números de serie ----------------//
  conceptSerialNumber(deliveryNote: InvoiceModel) {
    this.preinvoiceService.loadData(deliveryNote.uid).then(invoice => {
      this.conceptService.getListSerialNumbers().then(conceptsWithSerialNumbers => {
        const concepts: ConceptModel[] = conceptsWithSerialNumbers;
        let conceptUid: string;
        if (concepts.length > 0) {
          concepts.forEach(concept => {
            deliveryNote.invoiceLines.forEach(invoiceLine => {
              if (invoiceLine.product.includes(concept.name)) {
                console.log("Concepto con número de serie encontrado en factura");
                conceptUid = concept.uid;
                this.conceptService.getSerialNumbers(concept.uid).then(serialNumbers => {
                  serialNumbers.forEach(serialNumber => {
                    if (invoiceLine.product.includes(serialNumber.serialNumber)) {
                      console.log("Número de serie encontrado en factura");
                      serialNumber.invoiceUid = invoice.uid;
                      serialNumber.invoiceNumber = invoice.invoiceNumber;
                      this.conceptService.modifySerialNumbers(serialNumber, concept.uid).then(response => {
                        console.log("Número de serie actualizado");
                        this.conceptService.loadData(conceptUid).then(concept => {
                          concept.units = concept.units - 1;
                          this.conceptService.editData(conceptUid, concept).then(response => {
                            console.log("Concepto actualizado");
                          });
                        });
                      });
                    }
                  });
                });
              }
            });
          });
        }
      });
    });
  }
  //------------ Fin Conceptos con números de serie ----------------//

  convertToInvoice(): void {
    if (this.canPublishDeliveryNoteFifteenDays === true) {

      this.dialogsService.confirm("¿Convertir albarán en una factura del mes vigente ?", "Ten en cuenta que si aceptas no podrás generar facturas con fecha del mes anterior")
        .subscribe((res: boolean) => {

          if (res === true) {

            this.ready = true;

            this.invoiceService.convertDeliveryNoteInvoice([this.uid]).then(response => {

              const deliveryNote = response['data'];

              const responseMessage = response['message'];

              if (!Utils.IsNullOrEmpty(responseMessage)) {
                this.ready = true;
                this.displayInfo(responseMessage);
                return;
              }

              this.conceptSerialNumber(deliveryNote);
              this.ready = false;
              this.closeDialog('/invoice/issued');
            });
          } else {
            this.closeDialog('/invoice/deliverynote');
          }
        })
    } else {
      this.ready = true;

      this.invoiceService.convertDeliveryNoteInvoice([this.uid]).then(response => {

        const deliveryNote = response['data'];

        const responseMessage = response['message'];

        if (!Utils.IsNullOrEmpty(responseMessage)) {
          this.ready = true;
          this.displayInfo(responseMessage);
          return;
        }

        this.conceptSerialNumber(deliveryNote);
        this.ready = false;
        this.closeDialog('/invoice/issued');
      });

    }
  }

  /* convertToInvoiceFifteenDays(): void {
    this.ready = true;
    this.invoiceService.convertDeliveryNoteInvoiceFifteenDays([this.uid]).then(response => {
      this.ready = false;
      let deliveryNote = response;
      this.conceptSerialNumber(deliveryNote);
      this.closeDialog('/invoice/issued');
    });
  } */

  closeDialog(pathUrl: string = '/invoice/issued') {
    this.dialogRef.close(pathUrl);
  }

  ngOnInit() {
    this.invoiceService.canPublishDeliveryNoteFifteenDays(this.uid).then(response => {
      this.canPublishDeliveryNoteFifteenDays = response;
    }).catch(err => {
      console.log(err);
      this.canPublishDeliveryNoteFifteenDays = err['error']['data'];
    })
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, 'Cerrar', options);
  }
}
